import State from "slotworks/state-machine/states/state";
import DSComponents from "components/components";

export default class JackpotCelebration extends State {

    public onEnter() {
        DSComponents.scatterWin.start().then(() => this.complete());
    }
}
